import { useMemo } from "react";
import { useChatComposer } from "../ChatContext";
import { BaseAttachmentList } from "../attachments/BaseAttachmentList";
import { toDisplayAttachment, type ChatAttachment } from "../attachments/types";

export interface AttachmentListProps {
  className?: string;
  onRemove?: (id: string) => void;
  /**
   * Include attachments owned by a structured input (tagged — e.g. a
   * recommendation panel's image field). Default false: the freeform
   * message bar shows only its own attachments; tagged ones render
   * inside the panel that owns them.
   */
  showTagged?: boolean;
}

export function AttachmentList({ className, onRemove, showTagged = false }: AttachmentListProps) {
  const composer = useChatComposer();

  const displayAttachments: ChatAttachment[] = useMemo(
    () =>
      composer.attachments
        .filter((a) => showTagged || !a.tag)
        .map(toDisplayAttachment),
    [composer.attachments, showTagged]
  );

  const handleRemove = (id: string) => {
    if (onRemove) {
      onRemove(id);
    } else {
      composer.removeAttachment(id);
    }
  };

  return (
    <BaseAttachmentList
      attachments={displayAttachments}
      onRemove={handleRemove}
      className={className}
    />
  );
}
